export enum CaseTagTypeEnum {
    None = 0,
    Technology = 1,
    Material = 2,
    Component = 3,
    Device = 4,
    CoatingOrFilm = 5,
    ProcessImprovement = 6,
    Ingredient = 7,
    ApplicationOrMarket = 8,
    ProcessOrSystem = 9,
    MethodOrFrameworkOrModel = 10,
    Formula = 11,
    Product = 12
}
